export default __webpack_public_path__ + "static/media/sturdy_bone_shard.782e0838.png";